import WebService from "../../../../services/WebService";
import RawDataParser from "./RawDataParser";

/**
 * Post the request to mScore to get results
 */
export default class ResultWebService extends WebService {

    constructor() {
        super();
        this.rawDataParser = new RawDataParser();
    }

    /**
     *
     * @param {string} url
     * @param {Array.<EQmScoreStepProgress>} rawData the raw data
     * @return {Promise}
     */
    getResult(url, rawData = null) {
        if (rawData != null) {
            return this.postRaw(url, this.rawDataParser.formatLogs(rawData))
        }
        return this.get(url);
    }
}



// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/result/ResultWebService.js